// Dropdown functionality for sub offering
document.addEventListener('DOMContentLoaded', function () {
    var dropdownButton = document.getElementById('dropdownMenuButton');
    if (dropdownButton !== null) {
        dropdownButton.addEventListener('click', function () {
            var dropdownMenu = dropdownButton.nextElementSibling;
            if (dropdownMenu) {
                dropdownMenu.style.display = (dropdownMenu.style.display === 'block') ? 'none' : 'block';
            }
        });
    }
});

// Function to do autoscrolling after user clicking
$(function () {
    var selectedChild = $("#scroll").find(".active");
    var selectedContainer = document.getElementById("offerings");

    if ($(selectedChild).length) {
        selectedChild[0].scrollIntoView();
        selectedContainer.scrollIntoView();
    }
});